@if ({
  stockProtectionOverview: stockProtectionOverview$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  <!-- Filter and search -->
  <div class="stock-protection-filter">
    <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
      <ng-container>
        <div class="form-group row">
          <label for="uigArticleNumber" class="col-md-2 col-form-label">{{
            'customStockProtection.search.articleNumber' | cxTranslate
          }}</label>
          <div class="col-md-2">
            <input
              type="text"
              id="uigArticleNumber"
              class="form-control"
              ngModel
              name="uigArticleNumber"
              [value]="uigArticleNumber"
              />
            </div>
            <label for="uigProcess" class="col-md-2 col-form-label">{{
              'customStockProtection.uigProcess' | cxTranslate
            }}</label>
            <div class="col-md-2">
              <input
                type="text"
                id="uigProcess"
                class="form-control"
                ngModel
                name="uigProcess"
                [value]="uigProcess"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="scenario" class="col-md-2 col-form-label">{{
                'customStockProtection.search.scenario' | cxTranslate
              }}</label>
              <div class="col-md-6 col-lg-6 col-xl-6">
                <ng-select
                  id="scenario"
                  [searchable]="false"
                  [clearable]="false"
                  name="scenario"
                  [value]="scenario"
                  [(ngModel)]="selectedScenarioOption"
                  >
                  @for (filter of filterScenarioOptions; track filter) {
                    <ng-option [value]="filter">{{
                      'customStockProtection.scenarioFilter.' + filter | cxTranslate
                    }}</ng-option>
                  }
                </ng-select>
              </div>
            </div>
          </ng-container>
          <div class="form-group row">
            <div class="col-sm-3">
              <button class="btn btn-secondary btn-block mb-3" type="submit">
                {{ 'customStockProtection.buttons.search' | cxTranslate }}
              </button>
            </div>
            <div class="col-sm-3">
              <button class="btn btn-secondary btn-block mb-3" (click)="resetForm()">
                {{ 'customStockProtection.buttons.reset' | cxTranslate }}
              </button>
            </div>
            <div class="col-sm-6">
              <button
                class="btn btn-secondary btn-block"
                type="button"
                (click)="openInstructions()"
                >
                {{ 'customStockProtection.instructions.title' | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
        <div class="import-container">
          <hr>
            <div class="import-header">
              <p class="title"> {{ 'customStockProtection.importTitle' | cxTranslate }} </p>
              <p class="text"> {{ 'customStockProtection.importText' | cxTranslate }} </p>
            </div>
            <div class="form-group row import-buttons">
              <div class="col-sm-2 import-extra-column">
                &nbsp;
              </div>
              <div class="col-md-4 col-sm-6">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="customCSVImport" (change)="onFileSelected($event)">
                  @if (!fileName) {
                    <label class="custom-file-label" for="customCSVImport">
                      {{'customStockProtection.noFileSelected' | cxTranslate}}
                    </label>
                  }
                  @if (fileName) {
                    <label class="custom-file-label" for="customCSVImport">
                      {{fileName}}
                    </label>
                  }
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <button
                  class="btn btn-secondary btn-block"
                  type="button"
                  (click)="importFile()"
                  >
                  {{ 'customStockProtection.buttons.import' | cxTranslate }}
                </button>
              </div>
            </div>
            <hr>
            </div>
          </div>
          <div class="stock-protection-sort">
            <div class="form-group row">
              <label for="stockProtectionSorting" class="col-xl-2 col-form-label">{{
                'customStockProtection.sortOptions.label' | cxTranslate
              }}</label>
              <ng-select
                id="sortOptions"
                class="col-xl-2"
                [searchable]="false"
                [clearable]="false"
                (change)="onChangeSort()"
                [(ngModel)]="selectedSortOption"
                >
                @for (sort of sortOptions; track sort) {
                  <ng-option [value]="sort">{{
                    'customStockProtection.sortOptions.' + sort | cxTranslate
                  }}</ng-option>
                }
              </ng-select>
              <label for="sortDirections" class="col-xl-2 col-form-label">{{
                'customStockProtection.sortDirections' | cxTranslate
              }}</label>
              <div class="col-xl-2 col-form-label">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="sortDirection"
                    id="sortDirectionDesc"
                    value="desc"
                    ng-control="sortDirection"
                    [(ngModel)]="sortDirection"
                    (change)="onChangeSort()"
                    />
                    <label class="form-check-label" for="sortDirectionDesc">
                      {{ 'customStockProtection.sortDirection.desc' | cxTranslate }}
                    </label>
                  </div>
                </div>
                <div class="col-xl-2 col-form-label">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sortDirection"
                      id="sortDirectionAsc"
                      value="asc"
                      ng-control="sortDirection"
                      [(ngModel)]="sortDirection"
                      (change)="onChangeSort()"
                      />
                      <label class="form-check-label" for="sortDirectionAsc">
                        {{ 'customStockProtection.sortDirection.asc' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              @if (stockProtectionOverview || errorOverview) {
                <!-- TABLE -->
                <table class="table stock-protection-table">
                  <thead class="stock-protection-header">
                    <th scope="col">&nbsp;</th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col" colspan="2" class="toDateDeliverPeriodGroup">
                      {{ 'customStockProtection.deliveryPeriod' | cxTranslate }}
                    </th>
                    <th scope="col" colspan="2" class="fromDateMessageGroup">
                      {{ 'customStockProtection.reportingPeriod' | cxTranslate }}
                    </th>
                    <th scope="col" colspan="2" class="stockProtectionValue">
                      {{ 'customStockProtection.manufacturerPrice' | cxTranslate }}
                    </th>
                  </thead>
                  <thead class="stock-protection-thead-mobile">
                    <th scope="col" class="uigProcess">
                      {{ 'customStockProtection.uigProcess' | cxTranslate }}
                    </th>
                    <th scope="col" class="status">
                      {{ 'customStockProtection.status' | cxTranslate }}
                    </th>
                    <th scope="col" class="articleNumber">
                      {{ 'customStockProtection.articleNumber' | cxTranslate }}
                    </th>
                    <th scope="col" class="productInfo">
                      {{ 'customStockProtection.productInfo' | cxTranslate }}
                    </th>
                    <th scope="col" class="fromDateDeliverPeriodGroup">
                      {{ 'customStockProtection.fromDate' | cxTranslate }}
                    </th>
                    <th scope="col" class="toDateDeliverPeriodGroup">
                      {{ 'customStockProtection.toDate' | cxTranslate }}
                    </th>
                    <th scope="col" class="fromDateMessageGroup">
                      {{ 'customStockProtection.fromDate' | cxTranslate }}
                    </th>
                    <th scope="col" class="toDateMessageGroup">
                      {{ 'customStockProtection.toDate' | cxTranslate }}
                    </th>
                    <th scope="col" class="stockProtectionValue">
                      {{ 'customStockProtection.stockProtectionValue' | cxTranslate }}
                    </th>
                    <th scope="col" class="stockProtectionCurrency">
                      {{ 'customStockProtection.stockProtectionCurrency' | cxTranslate }}
                    </th>
                  </thead>
                  <tbody>
                    @if (stockProtections.length === 0) {
                      <tr>
                        <td colspan="10">
                          {{  'customStockProtection.emptyTable' | cxTranslate }}
                        </td>
                      </tr>
                    }
                    @for (stockProtection of stockProtections; track stockProtection) {
                      <tr>
                        <!--UIG Process Number-->
                        <td class="processNumber">
                          <div class="d-md-none stock-protection-label">
                            {{ 'customStockProtection.uigProcess' | cxTranslate }}
                          </div>
                          <div class="stock-protection-value">
                            <a
                              class="stock-protection-value"
                        (click)="openDetails(stockProtection?.processNumber,
                        stockProtection?.productCode, stockProtection?.inactive)"
                              >
                            {{ stockProtection?.processNumber }}</a>
                          </div>
                        </td>
                        <!--Status-->
                        <td class="status">
                          <div class="d-md-none stock-protection-label">
                            {{ 'customStockProtection.status' | cxTranslate }}
                          </div>
                          <div class="stock-protection-value">
                            <img
                        src="assets/images/stockprotection/{{
                            stockProtection?.state
                        }}.gif"
                              alt="{{ stockProtection?.state }}"
                        title="{{
                            'customStockProtection.states.' + stockProtection?.state
                              | cxTranslate
                          }}"
                              />
                            </div>
                          </td>
                          <!--Article Number-->
                          <td class="articleNumber">
                            <div class="d-md-none stock-protection-label">
                              {{ 'customStockProtection.articleNumber' | cxTranslate }}
                            </div>
                            <div class="stock-protection-value">
                              <a
                                class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: stockProtection.productCode }
                          } | cxUrl
                        "
                                class="stock-protection-value"
                                >
                                {{ stockProtection?.productCode }}
                              </a>
                            </div>
                          </td>
                          <!--Product Information-->
                          <td class="productInfo">
                            <div class="d-md-none stock-protection-label">
                              {{ 'customStockProtection.productInfo' | cxTranslate }}
                            </div>
                            <div class="stock-protection-value">
                              <a
                                class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: stockProtection.productCode }
                          } | cxUrl
                        "
                                class="stock-protection-value"
                                >
                                {{ stockProtection?.productTitle }}
                                <br>
                                  {{ stockProtection?.summary }}
                                </a>
                              </div>
                            </td>
                            <!--Delivery Period From-->
                            <td class="date">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.deliveryPeriodFrom' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.formattedDeliveryPeriodFrom  }}
                              </div>
                            </td>
                            <!--Delivery Period To-->
                            <td class="date">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.deliveryPeriodTo' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.formattedDeliveryPeriodTo }}
                              </div>
                            </td>
                            <!--Reporting Period From-->
                            <td class="date">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.reportingPeriodFrom' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.formattedReportingPeriodFrom }}
                              </div>
                            </td>
                            <!--Reporting Period To-->
                            <td class="date">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.reportingPeriodTo' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.formattedReportingPeriodTo }}
                              </div>
                            </td>
                            <!--Value-->
                            <td class="value">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.stockProtectionValue' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.value }}
                              </div>
                            </td>
                            <!--Currency-->
                            <td class="currency">
                              <div class="d-md-none stock-protection-label">
                                {{ 'customStockProtection.stockProtectionCurrency' | cxTranslate }}
                              </div>
                              <div class="stock-protection-value">
                                {{ stockProtection?.currency }}
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <cx-spinner></cx-spinner>
                  }
                }